import React from "react";
import logoinf1 from "../Assets/Logos/InfoImpo/LogoCn.png";
// import logoinf2 from "../Assets/Logos/InfoImpo/LogoYpfChango.png";
import logoinf3 from "../Assets/Logos/InfoImpo/LogoGas.png";
// import logoinf4 from "../Assets/Logos/InfoImpo/LogoCnLogistica.png";
import logoinf5 from "../Assets/Logos/InfoImpo/LogoNeca.png";
// import logoinf6 from "../Assets/Logos/InfoImpo/LogoMollar.png"; 
import logoinf7 from "../Assets/Logos/InfoImpo/LogoNecaSantiago.png";
import logoinf8 from "../Assets/Logos/InfoImpo/LogoCnSima.png";
import NAVBAR from "./NavBarNueva";
import NAVBARMOBILEOSC from "./NavBarMobile";
import { useTranslation } from "react-i18next";
import "./Infoimpo.css"

const Info = () => {
    // eslint-disable-next-line no-unused-vars
    const [t, i18next] = useTranslation("global");
    
    const handleDownload = () => {
    };

  return (
    <div className="home-container">
      <div className="home-containerInfo">
          <div className="BarraEscritorio">
          <NAVBAR></NAVBAR>
          </div>
          <div className="BarraMobile">
          <NAVBARMOBILEOSC></NAVBARMOBILEOSC>
          </div>
        <div className="txt-redesInfo">
          <div className="txt-container-InfoImpo">
            <div className="linea-titulo">
              <div className="badge-nuestra-empresa">
                <p className="nuestra-empresa">{t("li.OUR COMPANY")}</p>
              </div>
            </div>
            <h2 className={i18next.language === "es" ? "Quienes-title" : "Quienes-titleEN"}>{t("txtInfo.txt1")}</h2>
            {/*<h2 className="nuestra-info-txt"><span className="txt-empresa-span">CN GRUPO</span> nace como una empresa familiar y cuenta con más <span className="txt-empresa-span"> 35 años </span> de trayectoria, más de <span className="txt-empresa-span"> 35 años </span> más de <span className="txt-empresa-span"> 250 colaboradores </span> y <span className="txt-empresa-span"> 6 bases operativas </span> distribuidas en puntos estratégicos de Salta y norte de Chile. </h2>*/}
          </div>
        </div>
      </div>
      <div className="division-quines"></div>

      <div className="logos-info info-grid">
        <div className="logo-boton">
          <img src={logoinf1} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/Legajo Impositivo CN - 2024.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        {/* YPF El Chango (ya no forma parte del grupo, se deja el código por si vuelve)
        <div className="logo-boton">
          <img src={logoinf2} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/EESS CHANGO - Legajo Impositivo - 2024.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        */}
        <div className="logo-boton">
          <img src={logoinf3} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/GN Legajo Impositivo 04.2024.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        <div className="logo-boton">
          <img src={logoinf8} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/CN SIMA Legajo Impositivo.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        {/* CN Logística (empresa discontinuada, se deja el código por si vuelve)
        <div className="logo-boton">
          <img src={logoinf4} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/LCN Legajo Impositivo 04.2024.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        */}
        <div className="logo-boton">
          <img src={logoinf5} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/NECA Legajo Impositivo 04.2024.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        {/* Puesto El Mollar (empresa discontinuada, se deja el código por si vuelve)
        <div className="logo-boton">
          <img src={logoinf6} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/PEM Legajo Impositivo 04.2024.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
        */}
        <div className="logo-boton">
          <img src={logoinf7} alt="" className="logo-info" />
          <a 
                  href="https://webcontent.cn-grupo.net/Assets/CN/Legajo Impositivo Necaban.pdf" 
                  download 
                  onClick={handleDownload}
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                  <button className="info-btn">{t("txtInfo.txt2")}</button>
            </a>
        </div>
      </div>

      <div className="footer">
            <div className="footer-left">
              <p className="txt-foo">{t("txt-foo2.Footer1")}</p>
            </div>
            <div className="footer-right">
              <div className="footer-right-left">
                <a 
                  href="https://webcontent.cn-grupo.net/Assets/Politica/CN-GRUPO_ Política de privacidad.pdf" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="txt-foo-politicas"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Politicas de privacidad
                </a>
              </div>
              <div className="footer-right-right">
                <p className="txt-foo2">{t("txt-foo2.Footer", { year: new Date().getFullYear() })}</p>
              </div>
            </div>
          </div>
    </div>
  );
};

export default Info;
